import { render } from "./FTLOrder.vue?vue&type=template&id=349fd234&scoped=true&ts=true"
import script from "./FTLOrder.vue?vue&type=script&lang=ts"
export * from "./FTLOrder.vue?vue&type=script&lang=ts"

import "./FTLOrder.vue?vue&type=style&index=0&id=349fd234&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349fd234"]])

export default __exports__